import React, { useState } from 'react';
import { GraduationCapIcon } from '@phosphor-icons/react';
import NewsletterPopup from 'components/Dashboard/NewsletterPopup';
import { TOOLS } from 'config/tools';
import Sidebar from 'components/Sidebar';
import SearchOverlay from 'components/SearchOverlay';
import MobileHeader from 'components/MobileHeader';

export default function AITrainer() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [newsletterPopup, setNewsletterPopup] = useState(false);

    const tool = TOOLS.find(t => t.id === 'ai-trainer');

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                setSearch={setSearch}
                search={search}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>

                <div className='h-[100svh] overflow-y-auto'>
                    <div className='max-w-5xl mx-auto px-4 md:px-6 pt-20 pb-10'>

                        <div className='mb-8'>
                            <div className='flex items-center gap-4 mb-4'>
                                <div className='p-4 bg-orange-50 rounded-xl'>
                                    <GraduationCapIcon size={40} className='text-orange-600' />
                                </div>
                                <div>
                                    <h1 className='text-3xl font-bold text-black/90'>Formatore AI</h1>
                                    <p className='text-black/60 mt-1'>Formazione interattiva e personalizzata sull&apos;intelligenza artificiale</p>
                                </div>
                            </div>
                        </div>

                        <div className='bg-white border border-greylight rounded-xl p-8 mb-6'>
                            <h2 className='text-xl font-semibold text-black/90 mb-4'>Descrizione dello strumento</h2>
                            <p className='text-black/70 leading-relaxed mb-4'>
                                Il Formatore AI è una piattaforma di apprendimento interattiva che offre corsi personalizzati sull&apos;intelligenza
                                artificiale, adattati al livello di conoscenza e agli obiettivi specifici di ciascun utente.
                            </p>
                            <p className='text-black/70 leading-relaxed mb-4'>
                                La piattaforma offre:
                            </p>
                            <ul className='list-disc list-inside text-black/70 leading-relaxed space-y-2 mb-4'>
                                <li>Percorsi formativi personalizzati in base al ruolo e all&apos;esperienza</li>
                                <li>Esercizi pratici e casi d&apos;uso reali</li>
                                <li>Sessioni interattive con assistenti AI specializzati</li>
                                <li>Valutazioni continue per monitorare i progressi</li>
                                <li>Certificazioni al completamento dei moduli</li>
                                <li>Contenuti aggiornati con le ultime novità del settore</li>
                                <li>Workshop su strumenti specifici (ChatGPT, Claude, Midjourney, etc.)</li>
                            </ul>
                            <p className='text-black/70 leading-relaxed'>
                                Che tu sia un principiante o un utente avanzato, il Formatore AI ti guida attraverso un percorso di apprendimento
                                strutturato per massimizzare l&apos;efficacia dell&apos;IA nella tua attività professionale.
                            </p>
                        </div>

                        <div className='bg-orange-50 border border-orange-200 rounded-xl p-6'>
                            <h3 className='text-lg font-semibold text-black/90 mb-3'>Strumento in via di sviluppo</h3>
                            <p className='text-black/70 mb-4'>
                                Stiamo lavorando per rendere disponibile questo strumento il prima possibile.
                                Iscriviti alla newsletter per essere avvisato non appena sarà pronto!
                            </p>
                            <button
                                onClick={() => setNewsletterPopup(true)}
                                className='bg-orange-600 hover:bg-orange-700 text-white font-medium px-6 py-3 rounded-lg transition-colors duration-200'
                            >
                                Iscriviti alla newsletter
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <NewsletterPopup
                visible={newsletterPopup}
                setVisible={setNewsletterPopup}
                toolName={tool?.name}
            />
        </>
    );
}
